import { Component, ElementRef, ViewChild, WritableSignal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { StateService } from '../../services/state/state.service';
import { BookingService } from '../../services/booking/booking.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { AutomaticExtension } from '../../api/models/automatic-extension';
import { AccessibilityService } from '../../services/accessibility.service';

@Component({
    selector: 'otb-participant-count',
    templateUrl: './participant-count.component.html',
    styleUrls: ['./participant-count.component.scss', './participant-count.component.mags-sop.scss'],
    standalone: false,
})
export class ParticipantCountComponent {
    @ViewChild('mainForm') mainForm!: ElementRef<HTMLFormElement>;
    options: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
    aeSignal: WritableSignal<AutomaticExtension>;
    // Initial value is a string so ng-select can match it against the string
    // items array on first render — otherwise the placeholder is shown.
    participantsControl = new FormControl<string | number | null>('1', Validators.required);

    constructor(
        private stateService: StateService,
        private bookingService: BookingService,
        private sessStorageService: SessionStorageService,
        private accessibility: AccessibilityService,
    ) {
        const booking = this.bookingService.booking ?? this.sessStorageService.parseBookingFromStorage();
        this.aeSignal = booking.aESignal;

        if (booking?.participantsCount) {
            this.participantsControl.setValue(booking.participantsCount);
            const participantCountField = booking?.personalDataForm?.form_fields.find(
                (field) => field.name === this.bookingService.booking.automaticExtension!['field_name'],
            );
            if (participantCountField) {
                this.options = participantCountField.options;
            }
        }
    }

    get value(): string | number | null {
        return this.participantsControl.value;
    }

    set value(newValue: string | number | null) {
        this.participantsControl.setValue(newValue);
    }

    next(): void {
        this.participantsControl.markAsTouched();
        this.participantsControl.markAsDirty();

        if (this.participantsControl.invalid) {
            this.accessibility.focusFirstInvalidField(this.mainForm.nativeElement);
            return;
        }

        this.bookingService.booking.participantsCount = Number(this.participantsControl.value);
        this.writeToSessionStorage();
        this.stateService.next();
    }

    private writeToSessionStorage(): void {
        const sessData = this.sessStorageService.getPersonalData();
        const participantField = this.bookingService.booking.automaticExtension!['field_name'];

        if (sessData && participantField && sessData[participantField]) {
            sessData[participantField] = this.participantsControl.value;
            this.sessStorageService.persistPersonalData(JSON.stringify(sessData));
        }
    }
}
